import React from 'react';
import { Button } from '@mui/material';
import Typography from '@mui/material/Typography';
import { useAuthContext } from '../../../../contexts/authContext';

type Props = {
    title: string;
    onClick: any;
    startIcon?: JSX.Element | string | undefined;
    sx?: object | undefined;
    fullWidth?: false | boolean;
    disabled?: false | boolean;
    type?: 'button' | 'reset' | 'submit';
};

function ButtonGeneral({
    title,
    onClick,
    startIcon,
    sx,
    fullWidth,
    disabled,
    type = 'submit',
}: Props) {
    const { modeTheme } = useAuthContext();

    return (
        <>
            <Button
                variant="contained"
                type={type}
                startIcon={startIcon !== undefined ? startIcon : null}
                onClick={onClick}
                disabled={disabled}
                fullWidth={fullWidth}
                sx={sx}
            >
                <Typography
                    component="div"
                    sx={{
                        color:
                            modeTheme === 'darkMode'
                                ? 'primary.main'
                                : 'primary.contrastText',
                        fontSize: { lg: 14, md: 10.5, xs: 9 },
                    }}
                >
                    {title}
                </Typography>
            </Button>
        </>
    );
}

export default ButtonGeneral;
